import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import './_cookieNotification.scss';

const CookieNotification = () => {
  const [cookies, setCookie] = useCookies(['accepted']);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    setHidden(cookies.accepted);
  }, [cookies.accepted]);

  const setExpireDate = (days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    return date;
  };
  return (
    <div className={`row mx-0 cookie-container ${hidden ? 'hide' : ''}`}>
      <div className='col-md-8 cookie-text'>
        We use cookies to ensure you get the best experience.
        <p>
          If you continue to use this site we will assume that you are happy
          with our <Link to='/privacy-policy'>Privacy Policy</Link>
        </p>
      </div>
      <div className='col-md-3  btn-wrapper'>
        <span
          className='accept-btn'
          onClick={() => {
            setCookie('accepted', true, { expires: setExpireDate(1000) });
          }}
        >
          Accept
        </span>
      </div>
    </div>
  );
};

export default CookieNotification;
